module.exports = __webpack_public_path__ + "media/images/favicon/favicon-144-277c107fb46b6674ce948fdbd0621233.png";